<template>
    <body class="class-1" id="dinein">
      <!-- header -->
      <PosAppHeader />

  <div class="back-btn-container ml-4 mt-2">
        <button class="btn btn-secondary" @click="goBack">
          <i class="fas fa-arrow-left"></i> Back
        </button>
      </div>
      <!-- main box -->
      <div class="main_box">
        <div class="left_panel dineintables ml-4">
          <div class="d-flex flex-column w-100">

    <div class="tables d-flex flex-row flex-wrap align-content-start">
              <!-- Dynamic table cards based on API data -->
              <div
                   class="table-cards p-2 green" 
                  >
                <div class="d-flex flex-column align-items-center">
                    <div class="symbol" style="width: 50px; height: 50px;">
                      <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 512 512" style="enable-background:new 0 0 512 512;width:100%; height:100%" xml:space="preserve">
                                         <image style="overflow:visible;" width="512" height="512" xlink:href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAgAAAAIACAYAAAD0eNT6AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJ
                                        bWFnZVJlYWR5ccllPAAAAyFpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdp
                                        bj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6
                                        eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNS1jMDE0IDc5LjE1
                                        MTQ4MSwgMjAxMy8wMy8xMy0xMjowOToxNSAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJo
                                        dHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlw
                                        dGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAv
                                        IiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RS
                                        ZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpD
                                        cmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIChXaW5kb3dzKSIgeG1wTU06SW5zdGFuY2VJ
                                        RD0ieG1wLmlpZDo0Q0NDRTdENDA4QkYxMUVEQTkyRkMyNjdDNzJBREU4NiIgeG1wTU06RG9jdW1l
                                        bnRJRD0ieG1wLmRpZDo0Q0NDRTdENTA4QkYxMUVEQTkyRkMyNjdDNzJBREU4NiI+IDx4bXBNTTpE
                                        ZXJpdmVkRnJvbSBzdFJlZjppbnN0YW5jZUlEPSJ4bXAuaWlkOjRDQ0NFN0QyMDhCRjExRURBOTJG
                                        QzI2N0M3MkFERTg2IiBzdFJlZjpkb2N1bWVudElEPSJ4bXAuZGlkOjRDQ0NFN0QzMDhCRjExRURB
                                        OTJGQzI2N0M3MkFERTg2Ii8+IDwvcmRmOkRlc2NyaXB0aW9uPiA8L3JkZjpSREY+IDwveDp4bXBt
                                        ZXRhPiA8P3hwYWNrZXQgZW5kPSJyIj8+yynrpwAADkVJREFUeNrs3Wty2zYUgNGAww1k/4v0EtDp
                                        tOlk3CiRLBK4j3N+t45F4vERku0x5/wGAPRyuAQAIAAAAAEAAAgAAEAAAAACAAAQAACAAAAABAAA
                                        IAAAAAEAAAgAAEAAAAACAAAQAACAAAAABAAAIAAAQAAAAAIAABAAAIAAAAAEAAAgAAAAAQAACAAA
                                        QAAAAAIAABAAAIAAAAAEAAAgAAAAAQAACAAAQAAAgAAAAAQAACAAAAABAAAIAABAAAAAAgAAEAAA
                                        gAAAAAQAACAAAAABAAAIAABAAAAAAgAAEAAAgAAAAAEAAAgAAEAAAAACAAAQAACAAAAABAAAIAAA
                                        AAEAAAgAAEAAAAACAAAQAACAAAAABAAAIAAAAAEAAAIAABAAAIAAAAAEAAAgAAAAAQAACAAAQAAA
                                        AAIAABAAAIAAAAAEAAAgAAAAAQAACAAAQAAAAAIAAASASwAAAgAAEAAAgAAAAAQAACAAAAABAAAI
                                        AABAAAAAAgAAEAAAgAAAAAQAACAAAAABAAAIAABAAAAAAgAABAAAIAAAAAEAAAgAAEAAAAACAAAQ
                                        AACAAAAABAAAIAAAAAEAAFzt/Pj4uOLrzBu+t+H2cKXv37+7CPzRRWsihN8jz2Av6NHXFwMAdN/0
                                        L90jz4AvSgwAYNN//d99aX88E7ywS14oABTb+N/aH49kL+7z9zSNOwDsQ6/v2UfSFxc9TgDw1B86
                                        To4iG6vTAADsNy/s5Uexp2oRAIA95onv+3CDAKDf3nIUfZEiAAB7ym9ew1F44xQBANhLHryWw40D
                                        gH57yNHghYoAAOwdn17X4UYCQL8942j0YkUAAPaKf1/j4V4DQD/nDbXzzh/pWfHnE/0RIQB2Pf1H
                                        2SPnGeiFff7/HdkDUMG48OtctjeewV7cr77m1SHgFACAFU//offGDJ8BsFkD0PWp/zZHkhd59b/h
                                        7QUA7toTUuyLmX4KwEkAAPaqQCcAWS+sUwAArtwLUj2oZvw9AE4CALA3NQwAEQCAPalpAFzF2wAA
                                        9oCWMgeAUwAA7EVOAACALgHgFAAAe5ATAABAAAAAAuABPwkAYO0XAAn5HAAA9h4nAACAAAAAbgkA
                                        76EDwFpv771/B4D30AGgl+EtAABoSAAAgAAAAAQAACAAAAABUIkfZQSw5guAhPwoIwD2HCcAAIAA
                                        AABuCQDvpwDAGpfsuT8CwHvoANDDuPIEAABIRAAAQEOnS8BFVnwO5K23qj4+PiK+Jlg+F0AAEH3D
                                        f/RvjoKvDd4Zo4KAl3kLgK8sPDPA9wDEmpcIAE+0FhjjAMxTc1wArOMIrNeCMpN8TTBvaymz1/gM
                                        ADZDqD+PPSBR+gQAmz9gTrMhAAywGouE+wjmNw1i7ucAcERkUAHmOk4AsCAA5jzFDAGAhQDMfZwA
                                        YAHgm7fBsAYgAMBmDSAAUP59Nn9hgbUAAYAJ3/TJfwgBrAlU5zcB/n8SDBO95ab/p3/XAon1z/on
                                        AIJvFG5wz83a68KTOtaBF3gLwOJx5cSwScL9G9Cd80xgOAEAT8aQYN7ZsAlzAmAw9nn698QPNU8E
                                        rONN1vHD0xye+sGcpN848RkA1WihARHgFKAhAYDNH8xRBAAAIACo4KqjPE8W0OsUwNsAAgBs/mDO
                                        IgA8MQNgbRcAyteTBGDuup4CAAAQAGzmyAuwhrAsAAyYOhwhgjlM0Rg7DBjEHJjD9ItBbwEAQEP+
                                        HHD94nv3CcATBHhqpCAnAAAgAAAAAQAACIBGKr3v7T08oPva4bNMjQLApgeAPcUJgMHrEgDWDAQA
                                        AAgAFD2AtUIAXMMHLgAg8J56KMB2Ze/eAtaHfvd22QkACQcDYE2gDwFgwgPWAgQAJj5gDaADfw2Q
                                        HwuAD26CjR8BgAVBEIANHwHQ02w+aSwYe8dexHs3jSkazqeyKn8GwGIDgL2kYQAAAAIAAFgRAN53
                                        AYCge+nvAsB76ACQ29hxAgAABCUAAEAAAAACAAAQAACAAOjAjzICWMMFQEJ+lBEAe4gTAABAAACA
                                        ALiF918AIOAe+qcA8B46ADgBAACSGAIAABAAL/I5BgBrtwAAAARABj7ICIC9wwnAlzhKArBmCwAD
                                        CgBrtQAwsACwRguAkHwOAAB7xk9O9/nLhSkqADz5OwFoeGOmQQdgHc66dz4TAFWedEfWmwTAsrW3
                                        zZ7nLQARkDW8wNoCb+gWAMOECrWAiQOwJnlgEQAioPnCJwaw6WPzFwCIAbDpw526/iIgG0z8hdJi
                                        ifGMPUEAuOEWTjB+sRcIADfeQgrGK/YAAUCrhRWMURAACtACC8Ym1v7IATATDAQhYKEFY7LHxj+M
                                        p+cDYDQaGORZcC26GIdY44OfABggePLC2MPaHui1CoDHF08IWIjBmLOel+U3AT5XUSY7gCf+UpwA
                                        KEhPZGCsWa+dAPBiUVoI4i3MJj42f0/6BAuAiouzgRdvsRQBVNv8jWfjzAkAJQLJExTY7El2AjAs
                                        3ly8wN01npwCkOmpzFhlCx8CZHcM3LX4iVWijyUfVmNrUAoAUg1YMOYh5wmApzJWLojGGxHHkM2f
                                        EGuWDwESMQJs3IhcCHYCcMUAtrizcqE03ogwdmz+hFs7fQYAAJwAQMlTADCWMVaCBIBjWVZOBuON
                                        XWPG5k+pEwADGk9PYOySfLztfAvAUxkAvB+OX4rNY+E3KALY+SRlrLFyrHj6Z9X4+fJY8yFAAIgZ
                                        AeOJ/+bLIvwiIH+4BQBu2OTvOgGwaVNiEoCxSkdR3gLw/iwAJAoAv7IVAJwAiAAA6BIAV7/fJQIA
                                        IMkJgAgAgIYBcAcRwN2hCcYoAiDowBcBANDsBEAEAECSALjr+GsKAYwBjFGIfQIwTC4ARGBsd/0t
                                        gHHjRZgLQgMAvrrpz4UPxuECYOUFFwIARH7aD7lf3fkhwLHwBnhrwEQDY5WV93hmHxt3nwCMhS94
                                        bogPLKjwaMxah6xDoa34McCx6UY5GTDpwNgl2l4SZlys+gzA2PiiZ6AwYd8Ecb/ZsV45mRRrYZ1J
                                        J5UbDthk4A2rfxOgAgaAhgEgAvhmzGHMQM8AMLkAoGkA/IgAIYDYxNiBZgFgkgEgLBsHgNMAxCXG
                                        EDQNAJMNYwljCWOpcQA4DcCCjTFFxfETbgwdLhgWajC26LePHS4gFmgwxui3bx0uKBZmMNbot0+d
                                        ySef362NxZid484aRNo16DQJMenAGkS/Neh0DzHpQAjQjwDAZg/3jllRgACw0aQzXVvYOgfMwdjr
                                        W2qHmwgA/faewz3EkwOYwzgBAJUM5g4CoMUEUcgA/Vyx9qeONCcAAOAEAFQyBOB0EwFgggDgAUcA
                                        AAACAJUM5TjdRAAk2NQAsBcIgGSFDABt9yRvAaCSwVzFCQCoZDBHEAB1J4hCBuDKPSFdvDkBQDiB
                                        OYoTALidI04wNxAAWyaIQgbgjr0hVcQ5AQAAJwCgkmEDp5sIABMEAA84AgAAEACoZCjH6SYCIMGm
                                        BYC9QgAkK2QAsGc1PAFAJYO5CAIAlQzmAAKg+gRRyACs3DPCx50TAABwAgAqGRZxuokAMEEA8IAj
                                        AAAAAYBKhnKcbiIATBAAPOAIAABAAKCSoRynmwiABJsSAB5wBECyQgYAe9oDpwsOYH2jH58BwKIG
                                        xjgCwAQBgA572+meQLlFYSZ6rT6sCwIA/tskRtHXxfPXxRiAZgFggmDB5/O1c0qABxwnAGDTFwPA
                                        FfwUADZR37dr7PumIScAYHHPer2dBkCREwCLKDZ/XHuM24YBACYy7gEIACzsvj+MFageACYINhzc
                                        E4xXJwBg4uLegADAgu77wZiBcgFggmBjwb3COF2syu8B8PPABjhUZX2zvpU9AcDCFX2SCRmL867v
                                        weZP2QAwQQDwgLOBXwUM+yfocG1v+/oeEEAAsLGS313oqy3kNqVfX4dKb7U43SS87J8BMEHI9IQ6
                                        jNnl18fnN7AHBQwAExMLBa4VHjScAGBB9/pxzbx+BIAJwt5KnsZpmTk+i49V7EWpAsAEwcKAawgb
                                        90RvAWAhB3OFhgQAKtki7lr2HKMIgJQTxOKKRRz3lEqRunyMOgEAACcAoJKDvE7yXVOnmwgAEwQA
                                        kRr7AccJAAA05I8BsaOSI/9xoBnka3DPvY08bpxuslS2EwATBAB7VLIA8FQEAEH2Sp8BQCVj3Pne
                                        aEgAoJItxCR5YoOMAeADMgB0kObHAZ0AAIATAEhVyR2/N4w3aBUAJggAgtMJAJjAuJcgALAwgzkA
                                        IQNgmCBYnHEPMfbijFsnAGSdJCPBJKbH5j+MLZwAXD/YTRA8ReKe0WkcLhu7R+CLYQKbJJHGxjAm
                                        04ylYQyTdH1bOi7OTRdjmhw8uOcz+Lh45vuk5xN/ljGMfe+ff3BO6xgAdONDgAAgAAAAAQAACAAA
                                        QAAAAAIAABAAAIAAAAAEAAAgAAAAAQAACAAAQAAAAAIAABAAAIAAAAAEAAAgAABAAAAAAgAAEAAA
                                        gAAAAAQAACAAAAABAAAIAABAAAAAAgAAEAAAgAAAAAQAACAAAAABAAAIAABAAACAAAAABAAAIAAA
                                        AAEAAAgAAEAAAAACAAAQAACAAAAABAAAIAAAAAEAAAgAAEAAAAACAAAQAACAAAAAAQAACAAAQAAA
                                        AAIAABAAAIAAAAAEAAAgAAAAAQAACAAAQAAAAAIAABAAAIAAAAAEAAAgAAAAAQAAAgAAEAAAgAAA
                                        AAQAACAAAAABAAAIAABAAAAAAgAAEAAAgAAAAAQAACAAAAABAAAIAABAAAAAAgAAEAAAIAAAAAEA
                                        AAgAAEAAAAACAAAQAACAAAAABAAAIAAAAAEAAAgAAEAAAAACAAAQAACAAAAABAAAIAAAQAAAAAIA
                                        ABAAAIAAAAAEAAAgAAAAAQAACAAAQAAAAAIAABAAAMDl/hJgAMM46gkHnacUAAAAAElFTkSuQmCC" transform="matrix(1 0 0 1 0.4651 0.3953)">
                                        </image>
                                        </svg>
                                    </div>
                  <div class="table-number textcenter">
                     <span style="display: block;">{{ maintablename }}</span>
                      <span style="display: block;">{{ maintableprice }}</span>
                  </div>
                </div>
              </div>
            </div>


            <div class="tables d-flex flex-row flex-wrap align-content-start">
              <!-- Dynamic table cards based on API data -->
              
              <div v-for="order in orders" :key="order.id" 
                   class="table-cards p-2" 
                   @click="combineOrders(order.id)"
                   :class="{'green': order.tablesold === 0, 'red': order.tablesold === 1}"
                   >
                <div  class="d-flex flex-column align-items-center">
                    <div class="symbol">
                                        <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 512 512" style="enable-background:new 0 0 512 512;" xml:space="preserve">
                                         <image style="overflow:visible;" width="512" height="512" xlink:href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAgAAAAIACAYAAAD0eNT6AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJ
                                        bWFnZVJlYWR5ccllPAAAAyFpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdp
                                        bj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6
                                        eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNS1jMDE0IDc5LjE1
                                        MTQ4MSwgMjAxMy8wMy8xMy0xMjowOToxNSAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJo
                                        dHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlw
                                        dGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAv
                                        IiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RS
                                        ZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpD
                                        cmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIChXaW5kb3dzKSIgeG1wTU06SW5zdGFuY2VJ
                                        RD0ieG1wLmlpZDo0Q0NDRTdENDA4QkYxMUVEQTkyRkMyNjdDNzJBREU4NiIgeG1wTU06RG9jdW1l
                                        bnRJRD0ieG1wLmRpZDo0Q0NDRTdENTA4QkYxMUVEQTkyRkMyNjdDNzJBREU4NiI+IDx4bXBNTTpE
                                        ZXJpdmVkRnJvbSBzdFJlZjppbnN0YW5jZUlEPSJ4bXAuaWlkOjRDQ0NFN0QyMDhCRjExRURBOTJG
                                        QzI2N0M3MkFERTg2IiBzdFJlZjpkb2N1bWVudElEPSJ4bXAuZGlkOjRDQ0NFN0QzMDhCRjExRURB
                                        OTJGQzI2N0M3MkFERTg2Ii8+IDwvcmRmOkRlc2NyaXB0aW9uPiA8L3JkZjpSREY+IDwveDp4bXBt
                                        ZXRhPiA8P3hwYWNrZXQgZW5kPSJyIj8+yynrpwAADkVJREFUeNrs3Wty2zYUgNGAww1k/4v0EtDp
                                        tOlk3CiRLBK4j3N+t45F4vERku0x5/wGAPRyuAQAIAAAAAEAAAgAAEAAAAACAAAQAACAAAAABAAA
                                        IAAAAAEAAAgAAEAAAAACAAAQAACAAAAABAAAIAAAQAAAAAIAABAAAIAAAAAEAAAgAAAAAQAACAAA
                                        QAAAAAIAABAAAIAAAAAEAAAgAAAAAQAACAAAQAAAgAAAAAQAACAAAAABAAAIAABAAAAAAgAAEAAA
                                        gAAAAAQAACAAAAABAAAIAABAAAAAAgAAEAAAgAAAAAEAAAgAAEAAAAACAAAQAACAAAAABAAAIAAA
                                        AAEAAAgAAEAAAAACAAAQAACAAAAABAAAIAAAAAEAAAIAABAAAIAAAAAEAAAgAAAAAQAACAAAQAAA
                                        AAIAABAAAIAAAAAEAAAgAAAAAQAACAAAQAAAAAIAAASASwAAAgAAEAAAgAAAAAQAACAAAAABAAAI
                                        AABAAAAAAgAAEAAAgAAAAAQAACAAAAABAAAIAABAAAAAAgAABAAAIAAAAAEAAAgAAEAAAAACAAAQ
                                        AACAAAAABAAAIAAAAAEAAFzt/Pj4uOLrzBu+t+H2cKXv37+7CPzRRWsihN8jz2Av6NHXFwMAdN/0
                                        L90jz4AvSgwAYNN//d99aX88E7ywS14oABTb+N/aH49kL+7z9zSNOwDsQ6/v2UfSFxc9TgDw1B86
                                        To4iG6vTAADsNy/s5Uexp2oRAIA95onv+3CDAKDf3nIUfZEiAAB7ym9ew1F44xQBANhLHryWw40D
                                        gH57yNHghYoAAOwdn17X4UYCQL8942j0YkUAAPaKf1/j4V4DQD/nDbXzzh/pWfHnE/0RIQB2Pf1H
                                        2SPnGeiFff7/HdkDUMG48OtctjeewV7cr77m1SHgFACAFU//offGDJ8BsFkD0PWp/zZHkhd59b/h
                                        7QUA7toTUuyLmX4KwEkAAPaqQCcAWS+sUwAArtwLUj2oZvw9AE4CALA3NQwAEQCAPalpAFzF2wAA
                                        9oCWMgeAUwAA7EVOAACALgHgFAAAe5ATAABAAAAAAuABPwkAYO0XAAn5HAAA9h4nAACAAAAAbgkA
                                        76EDwFpv771/B4D30AGgl+EtAABoSAAAgAAAAAQAACAAAAABUIkfZQSw5guAhPwoIwD2HCcAAIAA
                                        AABuCQDvpwDAGpfsuT8CwHvoANDDuPIEAABIRAAAQEOnS8BFVnwO5K23qj4+PiK+Jlg+F0AAEH3D
                                        f/RvjoKvDd4Zo4KAl3kLgK8sPDPA9wDEmpcIAE+0FhjjAMxTc1wArOMIrNeCMpN8TTBvaymz1/gM
                                        ADZDqD+PPSBR+gQAmz9gTrMhAAywGouE+wjmNw1i7ucAcERkUAHmOk4AsCAA5jzFDAGAhQDMfZwA
                                        YAHgm7fBsAYgAMBmDSAAUP59Nn9hgbUAAYAJ3/TJfwgBrAlU5zcB/n8SDBO95ab/p3/XAon1z/on
                                        AIJvFG5wz83a68KTOtaBF3gLwOJx5cSwScL9G9Cd80xgOAEAT8aQYN7ZsAlzAmAw9nn698QPNU8E
                                        rONN1vHD0xye+sGcpN848RkA1WihARHgFKAhAYDNH8xRBAAAIACo4KqjPE8W0OsUwNsAAgBs/mDO
                                        IgA8MQNgbRcAyteTBGDuup4CAAAQAGzmyAuwhrAsAAyYOhwhgjlM0Rg7DBjEHJjD9ItBbwEAQEP+
                                        HHD94nv3CcATBHhqpCAnAAAgAAAAAQAACIBGKr3v7T08oPva4bNMjQLApgeAPcUJgMHrEgDWDAQA
                                        AAgAFD2AtUIAXMMHLgAg8J56KMB2Ze/eAtaHfvd22QkACQcDYE2gDwFgwgPWAgQAJj5gDaADfw2Q
                                        HwuAD26CjR8BgAVBEIANHwHQ02w+aSwYe8dexHs3jSkazqeyKn8GwGIDgL2kYQAAAAIAAFgRAN53
                                        AYCge+nvAsB76ACQ29hxAgAABCUAAEAAAAACAAAQAACAAOjAjzICWMMFQEJ+lBEAe4gTAABAAACA
                                        ALiF918AIOAe+qcA8B46ADgBAACSGAIAABAAL/I5BgBrtwAAAARABj7ICIC9wwnAlzhKArBmCwAD
                                        CgBrtQAwsACwRguAkHwOAAB7xk9O9/nLhSkqADz5OwFoeGOmQQdgHc66dz4TAFWedEfWmwTAsrW3
                                        zZ7nLQARkDW8wNoCb+gWAMOECrWAiQOwJnlgEQAioPnCJwaw6WPzFwCIAbDpw526/iIgG0z8hdJi
                                        ifGMPUEAuOEWTjB+sRcIADfeQgrGK/YAAUCrhRWMURAACtACC8Ym1v7IATATDAQhYKEFY7LHxj+M
                                        p+cDYDQaGORZcC26GIdY44OfABggePLC2MPaHui1CoDHF08IWIjBmLOel+U3AT5XUSY7gCf+UpwA
                                        KEhPZGCsWa+dAPBiUVoI4i3MJj42f0/6BAuAiouzgRdvsRQBVNv8jWfjzAkAJQLJExTY7El2AjAs
                                        3ly8wN01npwCkOmpzFhlCx8CZHcM3LX4iVWijyUfVmNrUAoAUg1YMOYh5wmApzJWLojGGxHHkM2f
                                        EGuWDwESMQJs3IhcCHYCcMUAtrizcqE03ogwdmz+hFs7fQYAAJwAQMlTADCWMVaCBIBjWVZOBuON
                                        XWPG5k+pEwADGk9PYOySfLztfAvAUxkAvB+OX4rNY+E3KALY+SRlrLFyrHj6Z9X4+fJY8yFAAIgZ
                                        AeOJ/+bLIvwiIH+4BQBu2OTvOgGwaVNiEoCxSkdR3gLw/iwAJAoAv7IVAJwAiAAA6BIAV7/fJQIA
                                        IMkJgAgAgIYBcAcRwN2hCcYoAiDowBcBANDsBEAEAECSALjr+GsKAYwBjFGIfQIwTC4ARGBsd/0t
                                        gHHjRZgLQgMAvrrpz4UPxuECYOUFFwIARH7aD7lf3fkhwLHwBnhrwEQDY5WV93hmHxt3nwCMhS94
                                        bogPLKjwaMxah6xDoa34McCx6UY5GTDpwNgl2l4SZlys+gzA2PiiZ6AwYd8Ecb/ZsV45mRRrYZ1J
                                        J5UbDthk4A2rfxOgAgaAhgEgAvhmzGHMQM8AMLkAoGkA/IgAIYDYxNiBZgFgkgEgLBsHgNMAxCXG
                                        EDQNAJMNYwljCWOpcQA4DcCCjTFFxfETbgwdLhgWajC26LePHS4gFmgwxui3bx0uKBZmMNbot0+d
                                        ySef362NxZid484aRNo16DQJMenAGkS/Neh0DzHpQAjQjwDAZg/3jllRgACw0aQzXVvYOgfMwdjr
                                        W2qHmwgA/faewz3EkwOYwzgBAJUM5g4CoMUEUcgA/Vyx9qeONCcAAOAEAFQyBOB0EwFgggDgAUcA
                                        AAACAJUM5TjdRAAk2NQAsBcIgGSFDABt9yRvAaCSwVzFCQCoZDBHEAB1J4hCBuDKPSFdvDkBQDiB
                                        OYoTALidI04wNxAAWyaIQgbgjr0hVcQ5AQAAJwCgkmEDp5sIABMEAA84AgAAEACoZCjH6SYCIMGm
                                        BYC9QgAkK2QAsGc1PAFAJYO5CAIAlQzmAAKg+gRRyACs3DPCx50TAABwAgAqGRZxuokAMEEA8IAj
                                        AAAAAYBKhnKcbiIATBAAPOAIAABAAKCSoRynmwiABJsSAB5wBECyQgYAe9oDpwsOYH2jH58BwKIG
                                        xjgCwAQBgA572+meQLlFYSZ6rT6sCwIA/tskRtHXxfPXxRiAZgFggmDB5/O1c0qABxwnAGDTFwPA
                                        FfwUADZR37dr7PumIScAYHHPer2dBkCREwCLKDZ/XHuM24YBACYy7gEIACzsvj+MFageACYINhzc
                                        E4xXJwBg4uLegADAgu77wZiBcgFggmBjwb3COF2syu8B8PPABjhUZX2zvpU9AcDCFX2SCRmL867v
                                        weZP2QAwQQDwgLOBXwUM+yfocG1v+/oeEEAAsLGS313oqy3kNqVfX4dKb7U43SS87J8BMEHI9IQ6
                                        jNnl18fnN7AHBQwAExMLBa4VHjScAGBB9/pxzbx+BIAJwt5KnsZpmTk+i49V7EWpAsAEwcKAawgb
                                        90RvAWAhB3OFhgQAKtki7lr2HKMIgJQTxOKKRRz3lEqRunyMOgEAACcAoJKDvE7yXVOnmwgAEwQA
                                        kRr7AccJAAA05I8BsaOSI/9xoBnka3DPvY08bpxuslS2EwATBAB7VLIA8FQEAEH2Sp8BQCVj3Pne
                                        aEgAoJItxCR5YoOMAeADMgB0kObHAZ0AAIATAEhVyR2/N4w3aBUAJggAgtMJAJjAuJcgALAwgzkA
                                        IQNgmCBYnHEPMfbijFsnAGSdJCPBJKbH5j+MLZwAXD/YTRA8ReKe0WkcLhu7R+CLYQKbJJHGxjAm
                                        04ylYQyTdH1bOi7OTRdjmhw8uOcz+Lh45vuk5xN/ljGMfe+ff3BO6xgAdONDgAAgAAAAAQAACAAA
                                        QAAAAAIAABAAAIAAAAAEAAAgAAAAAQAACAAAQAAAAAIAABAAAIAAAAAEAAAgAABAAAAAAgAAEAAA
                                        gAAAAAQAACAAAAABAAAIAABAAAAAAgAAEAAAgAAAAAQAACAAAAABAAAIAABAAACAAAAABAAAIAAA
                                        AAEAAAgAAEAAAAACAAAQAACAAAAABAAAIAAAAAEAAAgAAEAAAAACAAAQAACAAAAAAQAACAAAQAAA
                                        AAIAABAAAIAAAAAEAAAgAAAAAQAACAAAQAAAAAIAABAAAIAAAAAEAAAgAAAAAQAAAgAAEAAAgAAA
                                        AAQAACAAAAABAAAIAABAAAAAAgAAEAAAgAAAAAQAACAAAAABAAAIAABAAAAAAgAAEAAAIAAAAAEA
                                        AAgAAEAAAAACAAAQAACAAAAABAAAIAAAAAEAAAgAAEAAAAACAAAQAACAAAAABAAAIAAAQAAAAAIA
                                        ABAAAIAAAAAEAAAgAAAAAQAACAAAQAAAAAIAABAAAMDl/hJgAMM46gkHnacUAAAAAElFTkSuQmCC" transform="matrix(1 0 0 1 0.4651 0.3953)">
                                        </image>
                                        </svg>
                                    </div>
                  <div class="table-number textcenter">
                     <span style="display: block;">{{ order.table_name }}</span>
                      <span style="display: block;">{{ order.totalPrice }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </body>
  </template>
  
<script>
export default {
  data() {
    return {
      orders: [],
      menuVisible: false,
      totalTables: 0,
      availableTables: 0,
      busyTables: 0,
      maintablename: '',
      maintableprice: '',
      mainOrderId: 0,
      mainTableId: 0,
      reservedTables: 0,
      selectedSecondaryOrderId: null, 
    };
  },
  methods: {
    goBack() {
      this.$router.go(-1);
     
    },
    toggleMenu() {
      this.menuVisible = !this.menuVisible;
    },
    gotohome() {
      // Add navigation logic if needed
    },
    navigateToPos(order) {
      if (!this.$hasPermission('edit orders')) {
        this.$toast.error('Not Permitted');
        return;
      }
      this.$router.push({ name: "PosComponent", params: { orderId: order.id, tableId: order.tableId } });
    },
    async fetchDineInOrders() {
      try {
        this.$root.isLoading = true;
        this.loading = true;
        const token = localStorage.getItem('authToken');
        const response = await fetch(`${this.$BASE_API_URL}/api/orders/types?types=2`, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
          },
        });
        const data = await response.json();
        if (data.status && data.data) {
          this.orders = data.data;
          
          const mainOrders = this.orders.filter(order => order.id == this.mainOrderId);
          console.log(mainOrders);
          if (mainOrders.length > 0) {
  this.maintablename = mainOrders[0].table_name;
  this.maintableprice = mainOrders[0].grand_total;
}
this.orders = this.orders.filter(order => order.id != this.mainOrderId);
          this.calculateTableStats();
        }
      } catch (error) {
        console.error('Error fetching dine-in orders:', error);
      } finally {
        this.$root.isLoading = false;
        this.loading = false;
      }
    },
    calculateTableStats() {
      this.totalTables = this.orders.length;
      this.availableTables = this.orders.filter(order => order.tablesold === 0).length;
      this.busyTables = this.orders.filter(order => order.tablesold === 1).length;
      this.reservedTables = 0;
    },
    async combineOrders(selectedSecondaryOrderId) {
      this.selectedSecondaryOrderId = selectedSecondaryOrderId;
      if (!this.selectedSecondaryOrderId) {
        this.$toast.error('Please select an order to combine');
        return;
      }

      const token = localStorage.getItem('authToken');
      const appId = localStorage.getItem('appId');

      try {
        const response = await fetch(`${this.$BASE_API_URL}/api/orders/combine`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify({
            primary_order_id: this.mainOrderId,
            secondary_order_id: this.selectedSecondaryOrderId,
            appId: parseInt(appId),
          }),
        });

        const result = await response.json();

        if (result.status) {
          this.$toast.success('Orders combined successfully');
          await this.fetchDineInOrders(); // Refresh orders
        } else {
          this.$toast.error(result.message || 'Failed to combine orders');
        }
      } catch (error) {
        console.error('Error combining orders:', error);
        this.$toast.error('An error occurred while combining orders');
      }
    }
  },
  async created() {
    this.mainOrderId = this.$route.params.orderId;
    this.mainTableId = this.$route.params.tableId;
    await this.fetchDineInOrders();
  }
}
</script>
  
  <style>
  .green {
    background-color: #4CAF50; 
  }
  .red {
    background-color: #F44336; 
  }
  .table-cards {
    margin: 5px;
    border-radius: 8px;
    color: white;
    text-align: center;
    cursor: pointer;
  }
  </style>